import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C08LinkListProps = RenderingProps<C08LinkListFields, RenderingParams>;

export type C08LinkListFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type RenderingParams = {
  HeadlineTag?: string;
  HeadlineAlignment?: string;
  BackgroundColor?: string;
  NumberOfColumns?: string;
  CTAStyle?: string;
  ColumnAlignment?: string;
  SupportCopyAlignment?: string;
  CTAAlignment?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
